import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children, isLogged }) => isLogged ? children : <Navigate to='/login' />